import { render } from "./OpennessOrganizationsList.vue?vue&type=template&id=cf129356&scoped=true"
import script from "./OpennessOrganizationsList.vue?vue&type=script&lang=js"
export * from "./OpennessOrganizationsList.vue?vue&type=script&lang=js"

import "./OpennessOrganizationsList.vue?vue&type=style&index=0&id=cf129356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf129356"]])

export default __exports__